// Cart Drawer - PE v4 enhancer (2026-07-30) — the cart ENGINE is native
// Ascent (cart.js elements: cart-items, quantity-input, cart-remove,
// free-shipping-progress, note/estimator/promo modals) rendered inside the
// approved design markup (snippets/paex-cart-details.liquid). This file
// powers ONLY the PE delivery strip (the PDP's shared EDD engines) and
// analytics (the party-date picker was removed 2026-10-09, Sasha). Handlers
// bind ON the drawer element (Ascent's ModalDialog stops inner-click
// propagation to document).

(function () {
  if (window.paexCartEnhancer) return;
  window.paexCartEnhancer = true;

  var state = {
    eddConfig: null,
    eddTexts: {},
    eddTimer: null,
    contentAbort: null,
    sumOpen: false, // summary disclosure survives engine re-renders
    bundlesOpen: {}, // per-line bundle disclosures, keyed by line index
    observer: null,
    stockAnswer: null, // Halloween clock - PE §17: this open's /stock answer
    stockCap: null, // the worker's cap for that answer (a count at the cap is never printed)
    enterOnInput: false, // the current Enter press began inside the postal input
  };

  function drawer() {
    var el = document.getElementById('Cart-Drawer');
    return el && el.classList.contains('paex-cart') ? el : null;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function push(eventName, payload) {
    var el = drawer();
    if (!el || el.dataset.analytics !== 'true') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      phase: Number(el.dataset.phase) || 0,
    }, payload));
  }

  function cartPost(path, body) {
    // M6 (2026-08-27): ride the shared cart queue when available so these
    // fire-and-forget attribute writes (edd_postal) can no
    // longer land BETWEEN another mutation and its section paint. Still no
    // sections on purpose — an unforced full-details repaint would wipe the
    // open EDD editor mid-typing.
    var perform = function () {
      return fetch(root() + path, {
        method: 'POST',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (response) { return response.json().catch(function () { return null; }); });
    };
    var b = bridge();
    return b && typeof b.enqueue === 'function' ? b.enqueue(perform) : perform();
  }

  /* ---- cart mutations that repaint the drawer (product-form contract:
     sections in the request, SectionDynamicUpdate, publish, retrap).
     M5 (2026-08-03): the shared primitives live in paex-cart-bridge.js,
     emitted right before this file by paex-cart-drawer.liquid (deferred,
     so it is defined first); looked up at call time, no-op degrade when
     absent — the PE-drawer-only policy (drawer()) stays here. ---- */
  function bridge() {
    return window.PaexCartBridge || null;
  }

  function sectionsToRender() {
    var b = bridge();
    if (b) return b.sectionsToRender(drawer());
    return [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
  }

  function retrapDrawer() {
    var b = bridge();
    var el = drawer();
    if (b && el) b.retrapDrawer(el);
  }

  function cartMutate(path, payload) {
    // M6 (2026-08-27): delegate to the bridge queue when available — the
    // mutation runs alone, the paint is token-gated (a stale response can
    // never overwrite a newer one), publish rides after the paint. This
    // wrapper keeps the local contract: error toast here, resolve null on
    // failure so callers (crossAdd, removeCode) keep their semantics.
    // a REJECTED request (network error, content blocker, bot-protection
    // redirect, abort) used to escape every .then below: the cross-sell
    // button stayed grey and nothing was added (review 2026-10-10). Now it
    // resolves null + the native error toast, like a Shopify error reply.
    var failed = function () {
      if (typeof webvista !== 'undefined' && typeof webvista.popToast === 'function' && window.cartStrings && window.cartStrings.error) {
        webvista.popToast(window.cartStrings.error, 'error');
      }
      return null;
    };
    var b = bridge();
    if (b && typeof b.mutate === 'function') {
      return b.mutate(path, payload, { source: 'paex-cart' }).then(function (resp) {
        if (!resp) return null;
        if (resp.status && resp.message) {
          // /cart/add.js error shape {status, message, description}
          if (typeof webvista !== 'undefined' && typeof webvista.popToast === 'function') {
            webvista.popToast(resp.description || resp.message, 'error');
          }
          return null;
        }
        return resp;
      }).catch(failed);
    }
    var body = Object.assign({}, payload, {
      sections: sectionsToRender().map(function (s) { return s.section; }).join(),
      sections_url: window.location.pathname,
    });
    return fetch(root() + path, {
      method: 'POST',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json().catch(function () { return null; }); })
      .then(function (resp) {
        if (!resp) return null;
        if (resp.status && resp.message) {
          // /cart/add.js error shape {status, message, description}
          if (typeof webvista !== 'undefined' && typeof webvista.popToast === 'function') {
            webvista.popToast(resp.description || resp.message, 'error');
          }
          return null;
        }
        if (resp.sections && typeof SectionDynamicUpdate !== 'undefined') {
          SectionDynamicUpdate.updateSections(sectionsToRender(), resp.sections);
          retrapDrawer();
        }
        var b2 = bridge();
        if (b2) b2.publishCart('paex-cart', resp);
        return resp;
      })
      .catch(failed);
  }

  // cross-sell single-tap add (design SEC-13/14)
  function crossAdd(button) {
    if (button.classList.contains('loading')) return;
    var variantId = Number(button.dataset.variantId);
    if (!variantId) return;
    button.classList.add('loading');
    cartMutate('cart/add.js', { id: variantId, quantity: 1 })
      .then(function (resp) {
        // on success the whole details re-rendered (button is gone); if the
        // paint did not replace it, or on error, re-enable the surviving button
        if (button.isConnected) button.classList.remove('loading');
        if (resp) push('cross_sell_added', { variantId: variantId });
      })
      .catch(function () {
        if (button.isConnected) button.classList.remove('loading');
      });
  }

  // discount-code pill ✕ — reapply the remaining codes (Shopify replaces
  // the whole code set on cart/update.js `discount`)
  function removeCode(button) {
    var el = drawer();
    if (!el) return;
    var removed = button.getAttribute('data-code');
    var codes = [];
    el.querySelectorAll('[data-pill-code]').forEach(function (pill) {
      var code = pill.getAttribute('data-pill-code');
      if (code && code !== removed && codes.indexOf(code) === -1) codes.push(code);
    });
    var pillEl = button.closest('.paex-cart__pill');
    if (pillEl) pillEl.classList.add('is-busy');
    cartMutate('cart/update.js', { discount: codes.join(',') });
  }

  function initEdd() {
    if (state.eddTimer) clearInterval(state.eddTimer);
    if (state.contentAbort) state.contentAbort.abort();
    state.contentAbort = new AbortController();
    var el = drawer();
    var strip = el && el.querySelector('[data-cart-edd]');
    if (!strip) return;
    var dataNode = strip.querySelector('[data-paex-cart-edd-data]');
    try {
      state.eddConfig = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }
    state.eddTexts = state.eddConfig.texts || {};
    var signal = state.contentAbort.signal;

    document.addEventListener('paex:geo-ready', function () { eddRender(strip); }, { signal: signal });
    if (typeof PAEX_DEST_EVENT !== 'undefined') {
      document.addEventListener(PAEX_DEST_EVENT, function () { eddRender(strip); }, { signal: signal });
    }
    state.eddTimer = setInterval(function () {
      var host = drawer();
      if (host && host.hasAttribute('open')) eddRender(strip);
    }, 60000);
    eddRender(strip);
    // Halloween clock - PE (2026-10-09) §15: the clock loads at the END of
    // body (it may not exist yet) — listeners ride the same per-swap abort
    // signal, so they never pile up across re-renders
    if (el.hasAttribute('data-clock')) {
      ['paex:clock-ready', 'paex:clock-change', 'paex:clock-cutoff'].forEach(function (type) {
        document.addEventListener(type, clockPaint, { signal: signal });
      });
      clockPaint();
    }
  }


  // both controls of the postal editor (Change + the deadline box's "Get
  // your date") report its state, always together
  function eddSyncExpanded(strip, rowEl) {
    var open = String(Boolean(rowEl) && !rowEl.hidden);
    strip.querySelectorAll('[data-edd-change], [data-paex-clock-date]').forEach(function (button) {
      button.setAttribute('aria-expanded', open);
    });
  }

  function eddChange() {
    var el = drawer();
    var strip = el && el.querySelector('[data-cart-edd]');
    if (!strip) return;
    var rowEl = strip.querySelector('[data-edd-input-row]');
    if (!rowEl) return;
    rowEl.hidden = !rowEl.hidden;
    eddSyncExpanded(strip, rowEl);
    if (!rowEl.hidden) {
      var input = strip.querySelector('[data-edd-input]');
      if (input) input.focus();
    }
  }

  function eddRegionOf(postal) {
    var first = String(postal || '').trim().toUpperCase().charAt(0);
    var map = { A: 'NL', B: 'NS', C: 'PE', E: 'NB', G: 'QC', H: 'QC', J: 'QC', K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON', R: 'MB', S: 'SK', T: 'AB', V: 'BC', X: 'NT', Y: 'YT' };
    if (/^\d/.test(first)) return 'US';
    return map[first] || null;
  }

  function eddApply() {
    var el = drawer();
    var strip = el && el.querySelector('[data-cart-edd]');
    if (!strip) return;
    var input = strip.querySelector('[data-edd-input]');
    var error = strip.querySelector('[data-edd-error]');
    var clean = String((input && input.value) || '').replace(/\s+/g, '').toUpperCase();
    var isCA = /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(clean);
    var isUS = /^\d{5}(-\d{4})?$/.test(clean);
    if (!isCA && !isUS) {
      if (error) {
        error.textContent = state.eddTexts.error || '';
        error.hidden = !state.eddTexts.error;
      }
      return;
    }
    if (error) error.hidden = true;
    var pretty = isCA ? clean.slice(0, 3) + ' ' + clean.slice(3) : clean;
    if (typeof paexDestWrite === 'function') {
      paexDestWrite({ place: pretty, region: eddRegionOf(clean), postal: isCA ? pretty : '' }); // postal: the free shipping offer's zone input (2026-10-19)
    }
    cartPost('cart/update.js', { attributes: { edd_postal: pretty } }); // merge-only (B1.8)
    push('delivery_estimate_used', { manual: true });
    var rowEl = strip.querySelector('[data-edd-input-row]');
    if (rowEl) rowEl.hidden = true;
    eddSyncExpanded(strip, rowEl);
    // collapsing the editor must not drop focus to body: focus whichever
    // opener is visible (the strip's Change, or the deadline box's link
    // when the Halloween design hides the strip)
    var openers = [strip.querySelector('[data-edd-change]'), strip.querySelector('[data-paex-clock-date]')];
    var opener = openers.filter(function (b) { return b && b.offsetParent; })[0];
    if (opener) opener.focus();
    eddRender(strip);
  }

  function eddDest() {
    var dest = typeof paexDestRead === 'function' ? paexDestRead() : null;
    var geo = window.paexGeo || null;
    return { dest: dest, geo: geo };
  }

  function eddRender(strip) {
    if (!strip || !strip.isConnected || !state.eddConfig) return;
    var ctx = eddDest();
    var dest = ctx.dest;
    var geo = ctx.geo;
    var postal = (dest && dest.place && /\d/.test(dest.place) ? dest.place : '')
      || (geo && geo.postal) || '';
    var region = (dest && dest.region) || eddRegionOf(postal) || (geo && geo.regionCode) || null;
    var input = strip.querySelector('[data-edd-input]');
    if (input && !input.value && postal) input.value = postal; // pre-filled (B4.2)
    // (geo-note line removed per Sasha 2026-07-31 — the deliver-to place
    // on the right already shows the detected location)
    // PDP chain for the visible place: typed → geo postal → city → province → generic
    var deliverEl = strip.querySelector('[data-edd-deliver-text]');
    if (deliverEl) {
      var shownPlace = (dest && dest.place)
        || (geo && geo.postal) || (geo && geo.city) || (geo && geo.regionName)
        || state.eddTexts.genericPlace || '';
      deliverEl.textContent = (state.eddTexts.deliverTo || 'Deliver to {place}').replace('{place}', shownPlace);
    }

    if (typeof paexEddEstimate !== 'function') return;
    var base = paexEddEstimate(region || '*', state.eddConfig.edd);
    if (!base) return;
    eddPaint(strip, base, region);

    if (!strip.hasAttribute('data-edd-live')) return;
    var proxy = strip.dataset.eddProxy || '/apps/paex-edd';
    // strict allowlist pins the fetch to one same-origin app-proxy segment
    // (kills .. traversal, ?/# suffixes, backslash escapes in one move)
    if (!/^\/apps\/[A-Za-z0-9_-]+\/?$/.test(proxy)) proxy = '/apps/paex-edd';
    var clean = String(postal || '').replace(/\s+/g, '').toUpperCase();
    var live = null;
    // processing = the slowest cart line (Liquid-resolved); the proxy moves
    // the carrier pickup accordingly (Sasha 2026-09-21)
    var processing = state.eddConfig.edd.processing;
    // app mode (2026-10-04): the same AfterShip engine as the checkout EDD
    // widget, keyed by the first cart line; falls through to the proxy lanes
    if (strip.dataset.eddSource === 'app' && strip.dataset.eddAppVariant && typeof paexEddAppFetch === 'function') {
      live = paexEddAppFetch({
        shop: (window.Shopify && Shopify.shop) || '',
        productId: strip.dataset.eddAppProduct,
        variantId: strip.dataset.eddAppVariant,
        postal: clean,
        region: region,
        country: region === 'US' ? 'US' : 'CA',
      });
    } else if (/^[A-Z]\d[A-Z](\d[A-Z]\d)?$/.test(clean) || /^\d{5}(-\d{4})?$/.test(clean)) {
      live = typeof paexEddLiveFetch === 'function' ? paexEddLiveFetch(proxy, clean, processing) : null;
    } else if (geo && geo.city && geo.regionCode && typeof paexEddLiveFetchCity === 'function') {
      live = paexEddLiveFetchCity(proxy, geo.city, geo.regionCode, geo.country || 'CA', processing);
    }
    if (!live) return;
    var loading = strip.querySelector('[data-edd-loading]');
    // show the skeleton until the FIRST live answer paints this strip
    if (loading && !strip.hasAttribute('data-edd-live-done')) loading.hidden = false;
    live.then(function (key) {
      if (loading) loading.hidden = true;
      strip.toggleAttribute('data-edd-live-done', true);
      if (!key || !strip.isConnected) return;
      // never paint a live arrival that lands before the dispatch day
      if (typeof paexEddLiveAccepts === 'function' && !paexEddLiveAccepts(base, key)) return;
      var upgraded = Object.assign({}, base, {
        arrivalKey: key,
        arrival: new Date(key + 'T12:00:00Z'),
        live: true,
      });
      eddPaint(strip, upgraded, region);
    });
  }

  function eddPaint(strip, estimate, region) {
    var texts = state.eddTexts;
    var arriveBy = (strip.dataset.arriveBy || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(arriveBy)) arriveBy = '';
    var dateStr = typeof paexEddFormatDate === 'function' ? paexEddFormatDate(estimate.arrival) : '';
    var arrivesText = (texts.arrives || 'Arrives {date}').replace('{date}', dateStr);
    // Halloween clock - PE (2026-10-09): while the clock runs the deadline
    // box + line chips carry the verdict (paexClock's honest one: remote,
    // US and unknown destinations get none), so the strip stays the plain
    // "Arrives {date}" line — no second, possibly contradicting, badge
    var clockMode = Boolean(drawer() && drawer().hasAttribute('data-clock'));
    var inWindow = !clockMode && Boolean(arriveBy) && Number(strip.dataset.phase) > 0;
    var makesIt = inWindow && estimate.arrivalKey <= arriveBy;
    var missesIt = inWindow && estimate.arrivalKey > arriveBy && region; // never amber on a wildcard guess

    strip.toggleAttribute('data-resolved', true);
    strip.toggleAttribute('data-wont', Boolean(missesIt));
    // BOPIS: the date this strip shows is THE ship date of the cart — the mode
    // header / after-add strip (paex-fulfil.js shipDate) read it here instead
    // of re-running the base estimate (a live answer can be earlier)
    if (estimate.arrivalKey) strip.setAttribute('data-edd-arrival-key', String(estimate.arrivalKey).slice(0, 10));
    try { document.dispatchEvent(new CustomEvent('paex:cart-edd', { detail: { key: estimate.arrivalKey || null, live: Boolean(estimate.live) } })); } catch (error) { /* ignore */ }

    var label = strip.querySelector('[data-edd-label]');
    if (label) {
      var labelText = missesIt
        ? (texts.wont || '').replace('{occasion}', texts.occasion || '')
        : arrivesText;
      // only-if-changed: the lead is a live region — don't re-announce ticks
      if (label.textContent !== labelText) label.textContent = labelText;
    }
    strip.querySelectorAll('[data-edd-badge]').forEach(function (badge) {
      var show = makesIt && texts.badge;
      badge.textContent = show ? texts.badge : '';
      badge.hidden = !show;
    });
    var pivot = strip.querySelector('[data-edd-pivot]');
    var pivotShow = Boolean(missesIt || (Number(strip.dataset.phase) >= 3 && region));
    if (pivot) {
      if (pivotShow && pivot.hidden) push('pickup_pivot_shown', {});
      pivot.hidden = !pivotShow;
    }
  }

  /* ---- Halloween clock - PE (2026-10-09) §15: deadline box + per-line
     chips. Shipping lines carry data-paex-processing / data-paex-ship
     (paex-cart-details.liquid); ONE paexClock.estimate per distinct
     processing value (the live upgrade only while the drawer is open),
     and the box and the chips paint from the same answers:
       every shipping line on time → green box "cart_ontime {latest date}"
       some lines late           → amber box "cart_late_one/_other {n}"
       otherwise (unknown, remote, US, geo pending) → the server's neutral
       "Halloween in N days · Get your date" stays.
     Chips: green chip_ontime / amber chip_late / hidden (space kept by the
     row). The box keeps its server-reserved two lines in every state. ---- */
  var clockRun = 0;

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function clockPaint() {
    var el = drawer();
    var clock = window.paexClock;
    if (!el || !el.hasAttribute('data-clock') || !clock || !clock.state) return;
    var box = el.querySelector('[data-paex-cart-clock]');
    var lines = [];
    el.querySelectorAll('[data-paex-processing]').forEach(function (line) {
      if (line.getAttribute('data-paex-ship') !== 'true') return;
      var processing = parseInt(line.getAttribute('data-paex-processing'), 10);
      if (!(processing >= 0)) processing = 0;
      lines.push({ el: line, processing: Math.min(processing, 30) });
    });
    if (!box && !lines.length) return;
    var run = ++clockRun;
    var buckets = [];
    lines.forEach(function (line) {
      if (buckets.indexOf(line.processing) === -1) buckets.push(line.processing);
    });
    var live = el.hasAttribute('open');
    Promise.all(buckets.map(function (processing) {
      return clock.estimate({ processing: processing, live: live }).catch(function () { return null; });
    })).then(function (results) {
      if (run !== clockRun) return; // a newer paint (swap / clock change) owns the DOM
      var now = clock.state;
      var off = !now || now.phase === 'off';
      var late = 0;
      var onTime = 0;
      var latest = '';
      lines.forEach(function (line) {
        var result = results[buckets.indexOf(line.processing)];
        var verdict = off || !result ? 'unknown' : result.verdict;
        var tone = '';
        if (verdict === 'late') {
          late += 1;
          tone = 'warn';
        } else if (verdict === 'ontime' || verdict === 'lastday') {
          onTime += 1;
          tone = 'ok';
          // "everything arrives by {date}": the SAME date the drawer strip and the
          // PDP show (first day of a live range — Sasha 2026-10-09: all surfaces
          // agree); the verdict above was still judged on the latest day
          var date = result.estimate && result.estimate.date;
          if (date && date > latest) latest = date;
        }
        var chip = line.el.querySelector('[data-paex-line-eta]');
        if (!chip) return;
        setText(chip, tone === 'warn' ? clock.t('chip_late') : (tone === 'ok' ? clock.t('chip_ontime') : ''));
        if (tone) chip.setAttribute('data-tone', tone);
        else chip.removeAttribute('data-tone');
        chip.hidden = !tone;
      });
      if (!box) return;
      var msg = box.querySelector('[data-paex-clock-msg]');
      var act = box.querySelector('[data-paex-clock-act]');
      var link = box.querySelector('[data-paex-clock-date]');
      if (off) {
        // a page cached past Halloween: the clock no longer runs
        box.hidden = true;
        return;
      }
      // the design hides the old strip (and its Change button): the box's
      // own link stays in EVERY state — "Change" once a destination is known
      // (review 2026-10-09: the postal editor must always be reachable)
      var known = now.destination && now.destination.source !== 'none';
      if (late > 0) {
        box.setAttribute('data-tone', 'warn');
        setText(msg, late === 1 ? clock.t('cart_late_one') : clock.t('cart_late_other', { n: late }));
        setText(link, known ? clock.t('link_change') : clock.t('link_date_l'));
        if (act) act.hidden = false;
      } else if (lines.length && onTime === lines.length && latest) {
        box.setAttribute('data-tone', 'ok');
        setText(msg, clock.t('cart_ontime', { date: clock.fmtDate(latest) }));
        setText(link, known ? clock.t('link_change') : clock.t('link_date_l'));
        if (act) act.hidden = false;
      } else {
        box.setAttribute('data-tone', 'neutral');
        var days = now.phase === 'day' ? clock.t('day')
          : (now.phase === 'eve' ? clock.t('eve') : clock.t('days', { days: now.days }));
        setText(msg, days);
        setText(link, known ? clock.t('link_change') : clock.t('link_date_l'));
        if (act) act.hidden = false;
      }
    });
  }

  // the box's date button opens the strip's own postal editor (the drawer
  // is a modal with its own focus trap — no second sheet on top of it)
  function clockOpenEditor() {
    var el = drawer();
    var strip = el && el.querySelector('[data-cart-edd]');
    var rowEl = strip && strip.querySelector('[data-edd-input-row]');
    if (!rowEl) return;
    if (rowEl.hidden) {
      eddChange(); // opens the editor + syncs aria-expanded on both buttons
    } else {
      eddSyncExpanded(strip, rowEl);
      var input = strip.querySelector('[data-edd-input]');
      if (input) input.focus();
    }
  }

  /* ---- Halloween clock - PE (2026-10-09) §17: honest ONLINE stock lines
     (drawer toggle enable_stock_warning; data-stock-warning = threshold).
     Once per drawer open:
       - sold out since added: /products/{handle}.js variants[].available
         (default HTTP cache; at most once per handle per 5 min per tab —
         sessionStorage 'paex:stock-seen' — and never for a handle this tab
         just added: the successful add already proved it available); a line
         that turned unavailable → one queued refresh, the server then
         renders it in the sold-out branch;
       - low stock: GET {proxy}/stock?v=ids&cap=threshold+1 (online
         location, capped); "stock_low {n}" only for 1 ≤ n ≤ threshold. ANY
         failure (the route answers 500 until its admin token exists) → no
         line at all. No store stock is ever claimed. ---- */
  var STOCK_SEEN_KEY = 'paex:stock-seen';
  var STOCK_SEEN_MS = 5 * 60000;

  function stockSeenRead() {
    try {
      var map = JSON.parse(sessionStorage.getItem(STOCK_SEEN_KEY) || '{}');
      return map && typeof map === 'object' ? map : {};
    } catch (error) {
      return {};
    }
  }

  // stamp handles as checked now (drops stamps older than the window)
  function stockSeenStamp(handles) {
    if (!handles.length) return;
    var now = Date.now();
    var map = stockSeenRead();
    var next = {};
    Object.keys(map).forEach(function (handle) {
      var at = Number(map[handle]);
      if (at > 0 && now - at < STOCK_SEEN_MS) next[handle] = at;
    });
    handles.forEach(function (handle) { next[handle] = now; });
    try { sessionStorage.setItem(STOCK_SEEN_KEY, JSON.stringify(next)); } catch (error) { /* storage blocked */ }
  }

  // an /cart/add.js answer = the line(s) just added: {handle} for one line,
  // {items:[{handle}]} for several (a full cart object carries item_count —
  // that is a change/update answer, not an add)
  function stockSeenFromAdd(event) {
    var data = event && event.cartData;
    if (!data || typeof data !== 'object' || data.status) return;
    var handles = [];
    if (typeof data.handle === 'string') handles.push(data.handle);
    else if (Array.isArray(data.items) && data.item_count === undefined) {
      data.items.forEach(function (item) {
        if (item && typeof item.handle === 'string') handles.push(item.handle);
      });
    }
    stockSeenStamp(handles);
  }

  function stockLines() {
    var el = drawer();
    return el ? Array.prototype.slice.call(el.querySelectorAll('[data-paex-variant]')) : [];
  }

  function stockPaint() {
    var el = drawer();
    if (!el || !el.hasAttribute('data-stock-warning')) return;
    var threshold = parseInt(el.getAttribute('data-stock-warning'), 10) || 3;
    var answer = state.stockAnswer;
    var clock = window.paexClock;
    // the worker caps counts at its own STOCK_CAP and reports it: a value AT
    // the cap means "cap or more", never an exact count — so it is never
    // printed, whatever the theme threshold says (review 2026-10-09: a
    // theme that outruns the worker must not invent "Only 4 left")
    var cap = Number(state.stockCap);
    stockLines().forEach(function (line) {
      var slot = line.querySelector('[data-paex-line-stock]');
      if (!slot) return;
      var qty = answer && clock ? Number(answer[line.getAttribute('data-paex-variant')]) : NaN;
      var exact = qty >= 1 && qty <= threshold && (!(cap >= 1) || qty < cap);
      setText(slot, exact ? clock.t('stock_low', { n: qty }) : '');
    });
  }

  function stockFresh() {
    var el = drawer();
    if (!el || !el.hasAttribute('data-stock-warning')) return;
    var lines = stockLines();
    if (!lines.length) return;
    var threshold = parseInt(el.getAttribute('data-stock-warning'), 10) || 3;
    var b = bridge();

    // sold out since added (at most 12 product reads per open; a handle
    // checked or added in the last 5 min is skipped)
    var seen = stockSeenRead();
    var now = Date.now();
    var handles = [];
    lines.forEach(function (line) {
      var handle = line.getAttribute('data-paex-handle');
      var at = handle ? Number(seen[handle]) : 0;
      if (at > 0 && now - at < STOCK_SEEN_MS) return;
      if (handle && handles.indexOf(handle) === -1 && handles.length < 12) handles.push(handle);
    });
    Promise.all(handles.map(function (handle) {
      return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' },
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      stockSeenStamp(handles.filter(function (handle, i) { return Boolean(products[i]); }));
      var gone = false;
      products.forEach(function (product, i) {
        if (!product || !product.variants) return;
        lines.forEach(function (line) {
          if (line.getAttribute('data-paex-handle') !== handles[i]) return;
          var id = Number(line.getAttribute('data-paex-variant'));
          product.variants.forEach(function (variant) {
            if (variant.id === id && variant.available === false) gone = true;
          });
        });
      });
      if (gone && b && typeof b.refreshSections === 'function' && !el.hasAttribute('data-paex-cart-loading')) {
        b.refreshSections({ skeleton: true, source: 'paex-cart' });
      }
    });

    // low online stock (one capped read per open)
    var proxy = el.getAttribute('data-stock-proxy') || '/apps/paex-edd';
    if (!/^\/apps\/[A-Za-z0-9_-]+\/?$/.test(proxy)) proxy = '/apps/paex-edd';
    var ids = [];
    lines.forEach(function (line) {
      var id = line.getAttribute('data-paex-variant');
      if (line.querySelector('[data-paex-line-stock]') && /^\d+$/.test(id || '') && ids.indexOf(id) === -1 && ids.length < 50) ids.push(id);
    });
    state.stockAnswer = null;
    state.stockCap = null;
    stockPaint();
    if (!ids.length) return;
    fetch(proxy.replace(/\/$/, '') + '/stock?v=' + ids.join(',') + '&cap=' + (threshold + 1), {
      cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' },
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        state.stockAnswer = data && data.v && typeof data.v === 'object' ? data.v : null;
        // an answer without a cap (older worker) is treated as capped at 4,
        // its historical value — the safe side
        state.stockCap = data && data.cap >= 1 ? Number(data.cap) : (state.stockAnswer ? 4 : null);
        stockPaint();
      })
      .catch(function () { state.stockAnswer = null; state.stockCap = null; stockPaint(); });
  }

  /* ---------------- wiring — ON the element (ModalDialog stops inner
     clicks from reaching document) ---------------- */
  // BOPIS (lane D, 2026-10-22, seams §1 step 4): the mode controls inside the
  // drawer — all handled by paexFulfil.ui (assets/paex-fulfil.js); nothing
  // here runs for a visitor with no mode (the controls are not rendered).
  function fulfilUi() {
    return window.paexFulfil && paexFulfil.ui ? paexFulfil.ui : null;
  }

  function onDrawerClick(event) {
    var el = drawer();
    if (!el || !el.contains(event.target)) return;
    var ui = fulfilUi();
    if (ui) {
      var change = event.target.closest('[data-fulfil-change]');
      if (change) { event.preventDefault(); ui.openChooser(change); return; }
      if (event.target.closest('[data-aside-similar]')) return; // a plain link: let it navigate (design 4.7: Find similar only, no Add back)
      if (event.target.closest('[data-fulfil-postal-check]')) { event.preventDefault(); ui.postalApply(el); return; }
    }
    if (event.target.closest('[data-edd-check]')) { eddApply(); return; }
    var addItems = event.target.closest('[data-fso-add]');
    if (addItems) { offerAddItems(addItems); return; }
    if (event.target.closest('[data-fso-panel-close]')) { panelClose(true); return; }
    if (event.target.closest('[data-edd-change]')) { eddChange(); return; }
    if (event.target.closest('[data-paex-clock-date]')) { clockOpenEditor(); return; }
    var crossButton = event.target.closest('[data-cross-add]');
    if (crossButton) { crossAdd(crossButton); return; }
    var pillButton = event.target.closest('[data-pill-remove]');
    if (pillButton) { removeCode(pillButton); return; }
    if (event.target.closest('[data-sum-toggle]')) {
      state.sumOpen = !state.sumOpen;
      applySumState();
      return;
    }
    var bundleToggle = event.target.closest('[data-bundle-toggle]');
    if (bundleToggle) {
      var bIdx = bundleToggle.getAttribute('data-bundle-index');
      state.bundlesOpen[bIdx] = !state.bundlesOpen[bIdx];
      applyBundleState();
      return;
    }
    if (event.target.closest('[data-edd-pivot]')) {
      push('pickup_pivot_accepted', {});
      window.location.href = root() + 'checkout';
    }
  }

  // summary disclosure (design SEC-20/21): collapsed by default; state
  // lives here so it survives whole-details re-renders
  function applySumState() {
    var el = drawer();
    if (!el) return;
    var toggle = el.querySelector('[data-sum-toggle]');
    var sum = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!toggle || !sum) return;
    sum.hidden = !state.sumOpen;
    toggle.setAttribute('aria-expanded', String(state.sumOpen));
    var caret = toggle.querySelector('[data-sum-caret]');
    if (caret) caret.textContent = state.sumOpen ? '▴' : '▾';
    var foot = toggle.closest('.paex-cart__foot');
    if (foot) foot.toggleAttribute('data-sum-open', state.sumOpen);
  }

  // the drawer title sits OUTSIDE the re-rendered details — copy the fresh
  // count up on every swap (the marker is rendered inside the details)
  function syncCount() {
    var el = drawer();
    if (!el) return;
    var marker = el.querySelector('[data-paex-cart-count]');
    var target = el.querySelector('[data-paex-count]');
    if (marker && target) {
      var text = '(' + marker.getAttribute('data-paex-cart-count') + ')';
      if (target.textContent !== text) target.textContent = text;
    }
  }

  // bundle-contents disclosures (checkout parity) — state survives the
  // whole-details re-renders, keyed by line index
  function applyBundleState() {
    var el = drawer();
    if (!el) return;
    el.querySelectorAll('[data-bundle-toggle]').forEach(function (toggle) {
      var idx = toggle.getAttribute('data-bundle-index');
      var open = Boolean(state.bundlesOpen[idx]);
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      var label = toggle.querySelector('[data-bundle-label]');
      if (label) {
        var text = toggle.getAttribute(open ? 'data-label-hide' : 'data-label-show') || '';
        if (label.textContent !== text) label.textContent = text;
      }
      var caret = toggle.querySelector('[data-bundle-caret]');
      if (caret) caret.textContent = open ? '▴' : '▾';
    });
  }

  /* ---- Size advice backstop (Sasha 2026-10-05; TRACKING-FACTS §j.5). paex-cart-details.liquid marks each charted
     line lacking "_Size advice" / legacy _paex_sg (data-paex-sg-advice = sentence, data-paex-sg-key = line key); each
     is rewritten ONCE per page load: change.js {id: key, quantity: same, properties: every existing one + "_Size
     advice"} (_dk_* / app properties carried; _dk_gift skipped). After window load + idle; one queued task at a time
     (a shopper's write waits behind at most one stamp); one cart.js read per pass (each change.js response feeds the
     next task unless a tokened writer ran in between); sections ride the change.js and paint inside the task, so no
     stale key / index outlives it — meanwhile the native list lock + the line inert (no veil, no flicker). The paint
     marks the next charted lines (≤ 5 per render), which join the pass. 20 tries per page load; never in the editor. ---- */
  var sgAdv = { seen: {}, tries: 0, todo: [], running: false };

  function sizeAdviceSections() {
    var b = bridge();
    var el = document.getElementById('Cart-Drawer');
    var sections = b.sectionsToRender(el && el.dataset.section ? el : null);
    var main = document.getElementById('Main-Cart');
    if (main && main.dataset.section) {
      sections.push({ id: 'Main-Cart', section: main.dataset.section, selector: '#Main-Cart-Details' });
    }
    return sections;
  }

  // the native per-mutation lock (cart.js enableLoading) on every painted list + the rewritten line inert;
  // releases only what it set (a native click may have locked a list meanwhile)
  var sgLocked = [];
  function sizeAdviceLock(on, key, position) {
    if (on) {
      document.querySelectorAll('.cart-items-list:not(.cart-items--disabled)').forEach(function (list) { list.classList.add('cart-items--disabled'); sgLocked.push(list); });
    } else {
      sgLocked.forEach(function (list) { list.classList.remove('cart-items--disabled'); });
      sgLocked = [];
    }
    var lines = [];
    var el = document.getElementById('Cart-Drawer');
    if (el && key) {
      el.querySelectorAll('[data-paex-sg-key]').forEach(function (line) { if (line.getAttribute('data-paex-sg-key') === key) lines.push(line); });
    }
    var main = document.getElementById('Main-Cart');
    if (main && position) {
      main.querySelectorAll('.cart-item[id$="-' + position + '"]').forEach(function (line) { lines.push(line); });
    }
    lines.forEach(function (line) { try { line.inert = on; } catch (error) { /* pre-inert browsers: the list lock still holds */ } });
  }

  function sizeAdviceStep(cart, lastToken) {
    var b = bridge();
    var task = sgAdv.todo.shift();
    if (!task || !b) { sgAdv.running = false; return; }
    var next = { cart: null, token: null };
    b.enqueue(function () {
      var token = b.nextToken();
      next.token = token;
      var read = cart && typeof lastToken === 'number' && token === lastToken + 1
        ? Promise.resolve(cart)
        : fetch(root() + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; });
      var position = 0;
      return read
        .then(function (current) {
          var item = null;
          (current && current.items ? current.items : []).forEach(function (line, i) { if (!item && line.key === task.key) { item = line; position = i + 1; } });
          var props = (item && item.properties) || {};
          if (!item || props['_Size advice'] || props._paex_sg || props._dk_gift) { next.cart = current; return null; }
          var properties = {};
          Object.keys(props).forEach(function (k) { properties[k] = props[k]; });
          properties['_Size advice'] = task.text;
          var sections = sizeAdviceSections();
          sizeAdviceLock(true, task.key, position);
          return fetch(root() + 'cart/change.js', {
            method: 'POST',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: task.key,
              quantity: item.quantity,
              properties: properties,
              sections: sections.map(function (entry) { return entry.section; }).join(','),
              sections_url: window.location.pathname,
            }),
          })
            .then(function (response) { return response.json().catch(function () { return null; }); })
            .then(function (resp) {
              if (!resp || resp.status || !resp.items) return; // failed: the next task reads cart.js afresh
              if (resp.sections) b.applySections(sections, resp.sections, token);
              delete resp.sections;
              next.cart = resp;
            });
        })
        .catch(function () { /* best-effort: the line keeps its old state, never retried this page load */ })
        .then(function () { sizeAdviceLock(false, task.key, position); });
    }).then(function () { sizeAdviceStep(next.cart, next.token); });
  }

  function sizeAdviceStart() {
    var go = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(function () { sizeAdviceStep(null, null); }, { timeout: 2000 });
      else setTimeout(function () { sizeAdviceStep(null, null); }, 200);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  function sizeAdviceBackstop() {
    if (window.Shopify && Shopify.designMode) return;
    var b = bridge();
    var el = document.getElementById('Cart-Drawer');
    if (!el || !b || typeof b.enqueue !== 'function' || typeof b.nextToken !== 'function') return;
    el.querySelectorAll('[data-paex-sg-advice][data-paex-sg-key]').forEach(function (line) {
      var key = line.getAttribute('data-paex-sg-key');
      var text = line.getAttribute('data-paex-sg-advice');
      if (!key || !text || sgAdv.seen[key] || sgAdv.tries >= 20) return;
      sgAdv.seen[key] = true;
      sgAdv.tries += 1;
      sgAdv.todo.push({ key: key, text: text.slice(0, 200) });
    });
    if (!sgAdv.todo.length || sgAdv.running) return;
    sgAdv.running = true;
    sizeAdviceStart();
  }

  function syncDetails() {
    syncCount();
    applySumState();
    applyBundleState();
    initEdd();
    stockPaint(); // §17: re-apply this open's answer to the fresh lines (no refetch)
    sizeAdviceBackstop();
    offerSync(); // Free shipping offer - PE (2026-10-19): fresh totals → engine → meter + "Free*"
    // BOPIS (lane B, 2026-10-22): copy the re-rendered mode carrier
    // (<span data-paex-fulfil> beside the count) into paexFulfil — it clears
    // the attribute when the count carrier reads 0 (seams §1 step 3).
    if (window.paexFulfil && typeof paexFulfil.syncCarrier === 'function') paexFulfil.syncCarrier();
    // BOPIS (lane D): fill the fresh mode header (ready line / ship date /
    // same-day verdict), the CTA reason and the "Set aside" list
    var ui = fulfilUi();
    if (ui) ui.syncDrawer();
  }

  // Free shipping offer - PE: the re-rendered details carry the server's
  // totals and the count of lines that ship; the engine (loaded only while the
  // master switch is on) repaints the meter row and the summary's "Free*".
  function offerSync() {
    var el = drawer();
    if (el && window.paexShippingOffer && typeof paexShippingOffer.sync === 'function') paexShippingOffer.sync(el);
  }

  // "+ Add items" pill (design C2, phase 1; Sasha 2026-10-19 "the button add
  // items… is not clickable" = a short cart already showed the cross-sell rows,
  // so the scroll did nothing visible). Order: the merchant's link (Theme
  // settings › Free shipping offer › "+ Add items" pill link) → the drawer's
  // cross-sell rows (scroll + a 1.2 s highlight so the move is seen even when
  // they were already on screen) → the All products collection.
  function offerAddItems(button) {
    var el = drawer();
    var url = button.getAttribute('data-fso-add-url');
    if (button.getAttribute('data-fso-add-mode') !== 'url' && el && el.querySelector('[data-fso-panel]')) { panelOpen(); return; }
    if (button.getAttribute('data-fso-add-mode') === 'url' && url) {
      push('fso_add_items', { target: 'link' });
      window.location.href = url;
      return;
    }
    var rows = el && el.querySelector('[data-cross-sell]');
    if (rows && rows.offsetParent !== null && rows.scrollIntoView) {
      rows.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      rows.classList.remove('is-flash');
      void rows.offsetWidth; // restart the highlight on repeat taps
      rows.classList.add('is-flash');
      try { rows.focus({ preventScroll: true }); } catch (error) { rows.focus(); } // keyboard / AT land on the rows (review 2026-10-19)
      var status = el.querySelector('[data-paex-cart-loading-status]');
      var heading = rows.querySelector('.paex-cart__kicker');
      if (status && heading) { status.textContent = ''; status.textContent = heading.textContent.trim(); }
      setTimeout(function () { rows.classList.remove('is-flash'); }, 1400);
      push('fso_add_items', { target: 'crosssell' });
      return;
    }
    if (url) { push('fso_add_items', { target: 'collection' }); window.location.href = url; }
  }
  /* ---- Free shipping offer - PE phase 2 (design C7): the "+ Add items" panel.
     Markup = snippets/paex-cart-offer-panel.liquid, rendered OUTSIDE the
     re-rendered details. Up to four in-stock items whose price is closest to
     the amount left (prefer the ones that get the cart over the line), items
     already in the cart skipped, one-tap add through the cross-sell handler,
     closes by itself when the threshold is reached. ---- */
  var panelState = { open: false, lastRemaining: null };

  function panel() { var el = drawer(); return el && el.querySelector('[data-fso-panel]'); }

  function cartProductIds() {
    var el = drawer();
    var ids = {};
    if (!el) return ids;
    el.querySelectorAll('#Cart-Drawer-Details [data-product-id]').forEach(function (node) { ids[node.getAttribute('data-product-id')] = true; });
    return ids;
  }

  function panelPick() {
    var box = panel();
    var engine = window.paexShippingOffer;
    if (!box || !engine) return;
    var remaining = Number(engine.state.remaining) || 0;
    var inCart = cartProductIds();
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-fso-item]'));
    var scored = items.map(function (item) {
      var price = Number(item.getAttribute('data-price')) || 0;
      var over = price >= remaining;
      return { item: item, price: price, over: over, inCart: Boolean(inCart[item.getAttribute('data-product-id')]), gap: Math.abs(price - remaining) };
    }).filter(function (entry) { return !entry.inCart && entry.price > 0; });
    scored.sort(function (a, b) { return (a.over === b.over ? a.gap - b.gap : a.over ? -1 : 1); });
    var show = scored.slice(0, 4).map(function (entry) { return entry.item; });
    items.forEach(function (item) { item.hidden = show.indexOf(item) === -1; });
    var empty = box.querySelector('[data-fso-panel-empty]');
    if (empty) empty.hidden = show.length > 0;
    panelState.lastRemaining = remaining;
  }

  function panelOpen() {
    var box = panel();
    var el = drawer();
    if (!box || !el) return;
    panelPick();
    box.hidden = false;
    el.setAttribute('data-fso-panel-open', '');
    panelState.open = true;
    var title = box.querySelector('.paex-cart__paneltitle');
    if (title) title.focus();
    push('fso_panel_open', {});
  }

  function panelClose(toOpener) {
    var box = panel();
    var el = drawer();
    if (!box || !el) return;
    box.hidden = true;
    el.removeAttribute('data-fso-panel-open');
    panelState.open = false;
    if (toOpener) {
      var pill = el.querySelector('[data-fso-add]:not([hidden])') || el.querySelector('[data-sum-toggle]');
      if (pill) pill.focus();
    }
  }

  // ---- after-add message (phase 2): the offer line, 3 s under the header ----
  var toastTimer = null;
  var lastSubtotal = null;
  // BOPIS (lane D): a free-shipping line is never spoken in a pickup / same-day cart
  function fulfilStoreMode() {
    var svc = window.paexFulfil && typeof paexFulfil.service === 'function' ? paexFulfil.service() : null;
    return svc === 'pickup' || svc === 'local';
  }
  function offerToast(state) {
    var el = drawer();
    var toast = el && el.querySelector('[data-fso-toast]');
    if (!toast || !el.hasAttribute('open')) return;
    if (fulfilStoreMode()) return;
    if (!state.line || state.kind === 'teaser' || state.kind === 'none') return;
    toast.textContent = state.line;
    toast.hidden = false;
    toast.setAttribute('data-state', state.kind);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3000);
  }

  function onOfferChange(event) {
    var state = event && event.detail;
    if (!state) return;
    if (fulfilStoreMode()) { lastSubtotal = state.subtotal; return; } // BOPIS: no toast, no panel in a store-service cart
    // the panel follows the meter: re-pick on every change, close once unlocked
    if (panelState.open) {
      if (state.kind !== 'below') { panelClose(true); offerToast(state); }
      else if (state.remaining !== panelState.lastRemaining) panelPick();
    }
    if (lastSubtotal !== null && state.subtotal > lastSubtotal) offerToast(state);
    lastSubtotal = state.subtotal;
  }
  document.addEventListener('paex:offer-change', onOfferChange);

  function reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  // Enter submits the postal editor only when the Enter press STARTED in the
  // input (QAT audit 2026-10-09: Enter on the deadline box's link opened the
  // editor, focus moved to the input, and the same key's keyup applied + closed
  // it at once)
  function onDrawerKeydown(event) {
    state.enterOnInput = event.key === 'Enter' && Boolean(event.target.closest('[data-edd-input], [data-fulfil-postal-input]'));
  }

  function onDrawerKeyup(event) {
    var el = drawer();
    if (!el || !el.contains(event.target)) return;
    if (event.key === 'Escape' && panelState.open) { event.stopPropagation(); panelClose(true); return; } // Esc closes the panel, not the drawer
    if (event.key === 'Enter' && state.enterOnInput && event.target.closest('[data-edd-input]')) eddApply();
    // BOPIS (lane D): Enter in the same-day postal field of the mode header
    if (event.key === 'Enter' && state.enterOnInput && event.target.closest('[data-fulfil-postal-input]')) {
      var ui = fulfilUi();
      if (ui) ui.postalApply(el);
    }
    state.enterOnInput = false;
  }

  function bindDrawer() {
    var el = drawer();
    if (!el || el.dataset.paexBound) return;
    el.dataset.paexBound = '1';
    el.addEventListener('click', onDrawerClick);
    el.addEventListener('keydown', onDrawerKeydown);
    el.addEventListener('keyup', onDrawerKeyup);
  }

  // M6 (2026-08-27): freshness net on OPEN — a cart writer with no event
  // channel (another tab, an app without hooks) leaves the painted drawer
  // stale forever. On each closed→open transition, one tiny /cart.js read
  // compares the server count against the count stamped into the painted
  // HTML; a mismatch triggers ONE queued, token-gated refresh. Cost: a
  // ~1KB same-origin read per manual drawer open, nothing on page load.
  function verifyFreshOnOpen() {
    var el = drawer();
    var b = bridge();
    if (!el || !b || typeof b.refreshSections !== 'function') return;
    if (el.hasAttribute('data-paex-cart-loading')) return; // refresh already in flight (RCC path)
    var stamped = el.querySelector('[data-paex-cart-count]');
    if (!stamped) return;
    var painted = parseInt(stamped.getAttribute('data-paex-cart-count'), 10);
    if (isNaN(painted)) return;
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number' && cart.item_count !== painted) {
          b.refreshSections({ skeleton: true, source: 'paex-cart' });
        }
      })
      .catch(function () { /* net is best-effort; mutations self-heal */ });
  }

  function bindOpenFreshness() {
    var el = drawer();
    if (!el || el.dataset.paexFreshBound) return;
    el.dataset.paexFreshBound = '1';
    var wasOpen = el.hasAttribute('open');
    var opened = new MutationObserver(function () {
      var isOpen = el.hasAttribute('open');
      if (isOpen && !wasOpen) {
        verifyFreshOnOpen();
        // Halloween clock - PE (2026-10-09): live dates + online stock are
        // fetched only once the shopper actually opens the drawer
        clockPaint();
        stockFresh();
        // BOPIS (lane D, plan 6c): a same-day cart is re-validated on open
        // (postal / zone / minimum → header note + CTA), the ready line refreshed
        var ui = fulfilUi();
        if (ui) ui.sync();
      }
      wasOpen = isOpen;
    });
    opened.observe(el, { attributes: true, attributeFilter: ['open'] });
  }

  // v4: progress bar and CTA total render in Liquid inside
  // paex-cart-details (CartItems swaps the whole details per mutation) —
  // no DOM mirrors needed. Re-init watches the details container directly:
  // a MutationObserver catches EVERY swap path, including CartCodeModal's
  // SectionDynamicUpdate, which never publishes cartUpdate.
  var stockSeenBound = false;

  function boot() {
    var el = drawer();
    if (!el) return;
    // once per page (boot re-runs on every theme-editor section load)
    if (!stockSeenBound && el.hasAttribute('data-stock-warning')
      && typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && typeof webvista.subscribe === 'function') {
      stockSeenBound = true;
      webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, stockSeenFromAdd);
    }
    bindDrawer();
    bindOpenFreshness();
    syncDetails();
    var details = document.getElementById('Cart-Drawer-Details');
    if (details) {
      if (state.observer) state.observer.disconnect();
      state.observer = new MutationObserver(function () {
        requestAnimationFrame(syncDetails);
      });
      state.observer.observe(details, { childList: true });
    }
    try {
      if (!el.hasAttribute('data-status-silence')
        && new URLSearchParams(location.search).get('cart') === 'open'
        && el.show) el.show();
    } catch (error) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // theme editor re-renders replace the whole section DOM
  document.addEventListener('shopify:section:load', boot);
})();
